export default "__VITE_ASSET__335afe90__"